import type { ReactNode } from 'react';

export const symbol_explore_nearby: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-282q40-41 71.65-84.1 27.13-36.81 49.74-80.81Q624-490.9 624-534q0-60-42-102t-102-42q-60 0-102 42t-42 101.63q0 43.37 22.61 87.39t49.74 80.86Q440-323 480-282Zm-38.5-213.75Q426-511.5 426-534t15.5-38.25Q457-588 480-588t38.5 15.75Q534-556.5 534-534t-15.5 38.25Q503-480 480-480t-38.5-15.75Z"
		/>
	</svg>
);
